export default __webpack_public_path__ + "static/media/yellow-mark-guided-page.f2db9622.svg";